/* eslint-disable global-require,import/no-unresolved,max-len,class-methods-use-this */
import React from 'react'
import { Text } from 'react-native'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import textStyles from '../../styles/text'
import BulletedListView from '../subcomponents/BulletedListView'
import * as ResourceManager from '../methods/ResourceManager'
import Hyperlink from '../subcomponents/Hyperlink'
import * as evt from '../../actions/tapEvents'
import * as regionalLookup from '../methods/RegionalContentLookUp'
import styles from '../../styles'
import LightStageDetails from './LightStageDetails'

function ThreeSendingWavesPage(props) {
    const { t, patientManualTapped, regionalContentLookup } = props
    return (
      <LightStageDetails
        analyticsEvent="ThreeSendingWaves"
        sourceImage={ResourceManager.loadImage('three_sending_waves_header')}
        sourceImageStyle={{ width: 272, height: 59 }}
        accessibilityLabel={t('access:threeSendingWavesPageImage')}
      >
        <Text style={styles.lightStageHeader} testID="light-state-details-header">{t('common:yellowSendingThreeTitle')}</Text>
        <Text style={styles.lightStageDetailsHeading}>{t('whatItMeans')}</Text>
        <Text style={textStyles.bodyContentText}>{t('threeSendingWhatItMeansContentOne')}</Text>
        <Text style={styles.lightStageDetailsHeading}>{t('ifYouSeeThis')}</Text>
        <BulletedListView>
          <Hyperlink
            accessibilityLabel={t('access:confirmSwitchSettingsLink')}
            testID="confirm-switch-settings"
            textStyle={textStyles.detailText}
            linkText={`${t('common:connectionTypeTelephoneLineBulletFivePart2')} `}
            beforeText={t('common:connectionTypeTelephoneLineBulletFivePart1')}
            afterText={t('common:inLatitudePatientManual')}
            onPress={regionalContentLookup('manualURL') ? (() => patientManualTapped('switchSettings')) : null}
          />
        </BulletedListView>
        <BulletedListView
          headingText={t('common:connectionTypeInternetListTitle')}
        >
          <Text style={textStyles.detailText}>{t('threeSendingConnectionTypeInternetBulletOne')}</Text>
        </BulletedListView>
        <BulletedListView
          headingText={t('common:verifyTroubleshootingListTitle')}
        >
          <Text style={textStyles.detailText}>{t('verifyTroubleshootingBulletThree')}</Text>
          <Text style={textStyles.detailText}>{t('verifyTroubleshootingBulletFour')}</Text>
        </BulletedListView>
      </LightStageDetails>
    )
}

ThreeSendingWavesPage.propTypes = {
  t: PropTypes.func.isRequired,
  patientManualTapped: PropTypes.func.isRequired,
  regionalContentLookup: PropTypes.func.isRequired,
}

const actionCreators = {
  patientManualTapped: evt.patientManualTapped,
  regionalContentLookup: regionalLookup.regionalContentLookup,
}

export const ThreeSendingWavesPageComponent = ThreeSendingWavesPage

export default withTranslation(['indicatorLights', 'common'])(connect(null, actionCreators)(ThreeSendingWavesPage))
